<template>
  <a role="button" class="btn" v-bind:class="buttonType" v-link="menuUrl">
    <span class="glyphicon" v-bind:class="glyphIcon" aria-hidden="true"></span><br>
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    menuUrl: {default: '#'},
    glyphIcon: {default: 'glyphicon-list-alt'},
    buttonType: {default: 'btn-default'}
  }
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** MenuButton.vue?fbfd8440
 **/